export default __webpack_public_path__ + "images/87d5181a9ff49f5adbf8f2ed209c924b-startup_small_business.webp";